import React from 'react';
import { Box, Chip, Tooltip, IconButton, Badge } from '@mui/material';
import { Comment as CommentIcon, Star as StarIcon } from '@mui/icons-material';

/**
 * FeedbackIndicator Component
 *
 * Shows a visual indicator when a template has feedback
 * Displays rating and feedback count
 */
const FeedbackIndicator = ({
  feedback = [],
  analytics = null,
  compact = true,
  showRating = true,
  showCount = true,
}) => {
  // Don't show if no feedback
  if (!feedback || feedback.length === 0) {
    return null;
  }

  const feedbackCount = feedback.length;
  const averageRating = analytics?.average_rating || 0;
  const hasRating = averageRating > 0;

  if (compact) {
    return (
      <Tooltip
        title={`${feedbackCount} feedback${feedbackCount > 1 ? 's' : ''}${hasRating ? ` • ${averageRating.toFixed(1)}⭐` : ''}`}
        arrow
      >
        <Badge
          badgeContent={feedbackCount}
          color="primary"
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.7rem',
              height: '16px',
              minWidth: '16px',
            },
          }}
        >
          <IconButton
            size="small"
            sx={{
              color: hasRating ? 'warning.main' : 'primary.main',
              p: 0.5,
            }}
          >
            {hasRating ? (
              <StarIcon fontSize="small" />
            ) : (
              <CommentIcon fontSize="small" />
            )}
          </IconButton>
        </Badge>
      </Tooltip>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Chip
        icon={<CommentIcon />}
        label={`${feedbackCount} feedback${feedbackCount > 1 ? 's' : ''}`}
        size="small"
        color="primary"
        variant="outlined"
      />
      {hasRating && (
        <Chip
          icon={<StarIcon />}
          label={averageRating.toFixed(1)}
          size="small"
          color="warning"
          variant="filled"
        />
      )}
    </Box>
  );
};

export default FeedbackIndicator;
